import { render, staticRenderFns } from "./TxbMenu.vue?vue&type=template&id=682a26bc&scoped=true"
import script from "./TxbMenu.vue?vue&type=script&lang=js"
export * from "./TxbMenu.vue?vue&type=script&lang=js"
import style0 from "./TxbMenu.vue?vue&type=style&index=0&id=682a26bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682a26bc",
  null
  
)

export default component.exports